<div class="dib rel a-icon-tip-container">
  <i [ngClass]="icon"></i>
  <div class="a-icon-tip-panel a-icon-tip-left">
    <div class="a-icon-tip-inner">
      <i [ngClass]="icon"></i>
    </div>
    <ng-container *ngTemplateOutlet="tpl"></ng-container>
  </div>
</div>
